import { render, staticRenderFns } from "./repairPasword.vue?vue&type=template&id=58348d85&scoped=true&"
import script from "./repairPasword.vue?vue&type=script&lang=js&"
export * from "./repairPasword.vue?vue&type=script&lang=js&"
import style0 from "./repairPasword.vue?vue&type=style&index=0&id=58348d85&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58348d85",
  null
  
)

export default component.exports